import { useDispatch, useSelector } from 'store';
import { setCMS } from 'store/reducers/CMSSlice';
import CMSService from 'services/CMSService';

const useCMS = () => {
  const dispatch = useDispatch();
  const { cms } = useSelector((state) => state.cms);

  const fetchCMS = async (slug: string, lang: string, setToState: boolean = true) => {
    try {
      const resp = await CMSService.fetch(slug, lang);
      const results = resp?.data || {};

      if (setToState) {
        dispatch(setCMS(results));
      }

      return results;
    } catch (e) {
      dispatch(setCMS({}));
      console.error('fetchCMS', e);
      // throw e;
    }
  };

  return { cms, fetchCMS };
};

export default useCMS;
